import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BubbleTimelineComponent } from './bubble-timeline/bubble-timeline.component';
import { SharedModule } from '@shared/shared.module';

@NgModule({
  declarations: [BubbleTimelineComponent],
  imports: [CommonModule, SharedModule],
  exports: [BubbleTimelineComponent]
})
export class BubbleTimelineModule {}
